import {createBrowserRouter, Navigate} from "react-router-dom";
import {PageLayout} from "@/core/layout/PageLayout/PageLayout.tsx";

const BASE_URL = import.meta.env.VITE_BASE_URL;

export const appRouter = createBrowserRouter(
    [
        {
            path: "/",
            Component: PageLayout,
            children: [
                {path: "/", lazy: () => import("@/core/pages/HomePage/HomePage.tsx")},
                {path: "/homepage", element: <Navigate replace to="/"/>},
                {path: "/login", element: <Navigate replace to="/"/>},
                {
                    path: "/reports",
                    lazy: () => import("@/features/reports/pages/ReportOverviewPage/ReportOverviewPage.tsx"),
                },
                {
                    path: "/reports/:reportId",
                    lazy: () => import("@/features/reports/pages/ReportSummaryPage/ReportSummaryPage.tsx"),
                },
                {
                    path: "/impressum",
                    lazy: () => import("@/core/pages/ImpressumPage/ImpressumPage.tsx"),
                },
                {
                    path: "/privacy",
                    lazy: () => import("@/core/pages/PrivacyPage/PrivacyPage.tsx"),
                },
                {
                    path: "/accessibility",
                    lazy: () => import("@/core/pages/AccessibilityPage/AccessibilityPage.tsx"),
                },
                {
                    path: "*",
                    lazy: () => import("@/core/pages/NotFoundPage/NotFoundPage.tsx"),
                },
            ],
        },
    ],
    {basename: BASE_URL},
);
